import React, { Component, Fragment } from 'react';
import './styles.scss';
import InputAutocomplete from '../InputAutocomplete';
import AddUserDialog from '../AddUserDialog';
import AddSessionDialog from '../AddSessionDialog';
import Checkbox from '../Checkbox';
import { Form, FormTitle, FormContent, FormButton, FormClose } from '../Form';
import CreateGameMutation from '../../mutations/CreateGame';
import UpdateGameMutation from '../../mutations/UpdateGame';
const initialState = {
	typedUser: '',
	selectedUser: null,
	showAddUser: false,
	typedSession: '',
	selectedSession: null,
	showAddSession: false,
	typedTeam: '',
	selectedTeam: null,
	isCoordinator: false
};
class GameForm extends Component {
	constructor(props) {
		super(props);
		const { edit, game, defaultValues } = this.props;
		this.state = edit
			? {
				...initialState,
				typedUser: `${game.player.firstName} ${game.player.lastName}`,
				selectedUser: game.player.id,
				typedSession: game.session.name,
				selectedSession: game.session.id,
				typedTeam: game.data.team,
				selectedTeam: game.data.team,
				isCoordinator: game.data.leader
			  }
			: {
				...initialState,
				...defaultValues
			  };
		this.handleUserSelected = this.handleUserSelected.bind(this);
		this.handleNewUser = this.handleNewUser.bind(this);
		this.handleSessionSelected = this.handleSessionSelected.bind(this);
		this.handleNewSession = this.handleNewSession.bind(this);
		this.handleTeamSelected = this.handleTeamSelected.bind(this);
		this.createGame = this.createGame.bind(this);
		this.reset = this.reset.bind(this);
	}
	handleUserSelected(clickedUser) {
		this.setState({
			typedUser: clickedUser.label,
			selectedUser: clickedUser.value
		});
	}
	handleNewUser() {
		this.setState({
			showAddUser: true,
			selectedUser: null,
			typedUser: ''
		});
	}
	handleSessionSelected(clickedSession) {
		this.setState({
			typedSession: clickedSession.label,
			selectedSession: clickedSession.value
		});
	}
	handleNewSession() {
		this.setState({
			showAddSession: true,
			selectedSession: null,
			typedSession: ''
		});
	}
	handleTeamSelected(clickedTeam) {
		this.setState({
			typedTeam: clickedTeam.label,
			selectedTeam: clickedTeam.label
		});
	}
	reset() {
		const { defaultValues, reset } = this.props;
		reset && reset()
		this.setState({
			...initialState,
			...defaultValues
		});
	}
	createGame(createGameMutation) {
		const {
			selectedUser,
			selectedSession,
			selectedTeam,
			isCoordinator
		} = this.state;
		const { closeForm } = this.props;
		const data = {
			playerID: selectedUser,
			sessionID: selectedSession,
			team: selectedTeam,
			leader: isCoordinator
		};
		createGameMutation({ variables: { data } }).then(() => {
			this.reset();
			closeForm();
		});
	}
	updateGame(updateGameMutation) {
		const {
			selectedUser,
			selectedSession,
			selectedTeam,
			isCoordinator
		} = this.state;
		const { closeForm, game } = this.props;
		const data = {
			team: selectedTeam,
			leader: isCoordinator
		};
		updateGameMutation({
			variables: {
				playerID: selectedUser,
				sessionID: selectedSession,
				gameID: game.id,
				data
			}
		}).then(() => {
			this.reset();
			closeForm();
		});
	}
	render() {
		const { users, sessions, teams, closeForm, edit } = this.props;
		const {
			typedUser,
			typedSession,
			typedTeam,
			isCoordinator,
			showAddUser,
			showAddSession,
			selectedUser,
			selectedSession,
			selectedTeam
		} = this.state;
		const disabled = !selectedUser || !selectedSession || !selectedTeam;
		return (
			<Fragment>
				{showAddUser && (
					<AddUserDialog
						closeDialog={() => this.setState({ showAddUser: false })}
						onUserCreated={user =>
							this.setState({
								selectedUser: user.id,
								typedUser: `${user.firstName} ${user.lastName}`,
								showAddUser: false
							})
						}
					/>
				)}
				{showAddSession && (
					<AddSessionDialog
						closeDialog={() => this.setState({ showAddSession: false })}
						onSessionCreated={session =>
							this.setState({
								selectedSession: session.id,
								typedSession: session.name,
								showAddSession: false
							})
						}
					/>
				)}
				<UpdateGameMutation>
					{updateGameMutation => (
						<CreateGameMutation>
							{createGameMutation => (
								<Form className={'GameForm'} style={{ height: 'auto' }}>
									<FormClose onClickClose={closeForm} />
									<FormTitle>
										{edit ? 'Update Game' : 'Create a Game'}
									</FormTitle>
									<FormContent>
										<InputAutocomplete
											key={'user'}
											name={'user'}
											changed={typedUser =>
												this.setState({ typedUser, selectedUser: null })
											}
											itemSelected={this.handleUserSelected}
											value={typedUser}
											placeholder="Select User"
											styles={{ marginRight: '20px', width: '190px' }}
											items={users.map(user => ({
												value: user.id,
												label: `${user.firstName} ${user.lastName}`
											}))}
											footer={
												<div
													className="create-new"
													onClick={this.handleNewUser}
												>
													+ Add User
												</div>
											}
										/>
										<InputAutocomplete
											key={'session'}
											name={'session'}
											changed={typedSession =>
												this.setState({ typedSession, selectedSession: null })
											}
											itemSelected={this.handleSessionSelected}
											value={typedSession}
											placeholder="Select Session"
											styles={{ marginRight: '20px', width: '190px' }}
											items={sessions.map(session => ({
												value: session.id,
												label: session.name
											}))}
											footer={
												<div
													className="create-new"
													onClick={this.handleNewSession}
												>
													+ Add Session
												</div>
											}
										/>
										<InputAutocomplete
											key={'team'}
											name={'team'}
											changed={typedTeam =>
												this.setState({ typedTeam, selectedTeam: typedTeam })
											}
											itemSelected={this.handleTeamSelected}
											value={typedTeam}
											placeholder="Select Team"
											styles={{ marginRight: '20px', width: '190px' }}
											items={teams}
										/>
										<Checkbox
											clicked={() =>
												this.setState({ isCoordinator: !isCoordinator })
											}
											checked={isCoordinator}
										>
											Coordinator
										</Checkbox>
										<FormButton
											disabled={disabled}
											onClick={
												edit
													? () => this.updateGame(updateGameMutation)
													: () => this.createGame(createGameMutation)
											}
										>
											{edit ? 'Save' : 'Create New'}
										</FormButton>
									</FormContent>
								</Form>
							)}
						</CreateGameMutation>
					)}
				</UpdateGameMutation>
			</Fragment>
		);
	}
}
GameForm.defaultProps = {
	edit: false,
	defaultValues: {}
};
export default GameForm;
